"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var UNIVERSAL_LINK_PREFIX = 'https://links.sportheroes.com/';

var getLinksFromUrlParams = function getLinksFromUrlParams(urlParams, platformType) {
  var _ref = urlParams || {},
      prefix = _ref.prefix,
      path = _ref.path,
      params = _ref.params;

  var queryParams = params ? "?".concat(new URLSearchParams(params).toString()) : '';

  try {
    return platformType === 'web' ? new URL("".concat(path).concat(queryParams), prefix).toString() : "".concat(prefix).concat(path).concat(queryParams);
  } catch (error) {
    return "".concat(prefix).concat(path).concat(queryParams);
  }
};

var getUniversalLink = function getUniversalLink(_ref2) {
  var app = _ref2.app,
      web = _ref2.web;

  if (app && !web) {
    return getLinksFromUrlParams(app, 'app');
  } else if (web && !app) {
    return getLinksFromUrlParams(web, 'web');
  } else if (app && web) {
    var appUrlParam = encodeURIComponent(getLinksFromUrlParams(app, 'app'));
    var webUrlParam = encodeURIComponent(getLinksFromUrlParams(web, 'web'));
    return "".concat(UNIVERSAL_LINK_PREFIX, "?web=").concat(webUrlParam, "&app=").concat(appUrlParam);
  }

  return '';
};

var _default = getUniversalLink;
exports["default"] = _default;
//# sourceMappingURL=index.js.map